import "leader-line";

declare var LeaderLine: any;

export class CVFBoard {

    public lines: any[] = [];
    public LeaderLineColor: string = "#2AA3EE";
    public LeaderLineWarningColor: string = "#FFAF89";
    public leaderLineOptions: any = {
        startSocketGravity: 60,
        endSocketGravity: 60,
        path: "fluid",
        startPlug: "arrow1",
        startPlugSize: 1,
        endPlug: "disc",
        endPlugSize: 2,
        size: 2,
        color: this.LeaderLineColor,
    };

    public initLink(from, to) {
        return new LeaderLine(from, to, this.leaderLineOptions);
    }
}
